"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var recompose_1 = require("recompose");
var chevron_left_1 = __importDefault(require("material-ui/svg-icons/navigation/chevron-left"));
var chevron_right_1 = __importDefault(require("material-ui/svg-icons/navigation/chevron-right"));
var Input_1 = __importDefault(require("../Input"));
var Select_1 = __importDefault(require("../Select"));
var IconButton_1 = __importDefault(require("../IconButton"));
var debounced_1 = __importDefault(require("../debounced"));
var utils_1 = require("./utils");
var pageSizeValueFunc = function (_a) {
    var id = _a.id;
    return id;
};
var DebouncedInput = recompose_1.compose(recompose_1.withProps(function (_a) {
    var page = _a.page, emptyInput = _a.emptyInput;
    return ({
        value: emptyInput ? '' : page + 1,
    });
}), recompose_1.withHandlers({
    onChange: function (_a) {
        var setEmptyInput = _a.setEmptyInput, setPage = _a.setPage, pageSize = _a.pageSize, pageCount = _a.pageCount, refresh = _a.refresh, maxCount = _a.maxCount, onMaxCountReached = _a.onMaxCountReached;
        return function (value) {
            if (value === '' || value === undefined) {
                setEmptyInput(true);
            }
            else {
                setEmptyInput(false);
                var numberValue = Number(value);
                var page = pageCount === 0 || isNaN(numberValue)
                    ? 0
                    : numberValue >= pageCount
                        ? pageCount - 1
                        : numberValue > 1
                            ? numberValue - 1
                            : 0;
                if (maxCount && (page + 1) * pageSize > maxCount) {
                    setPage(Math.max(Math.floor(maxCount / pageSize) - 1, 0));
                    onMaxCountReached();
                    refresh();
                }
                else {
                    setPage(page);
                }
            }
        };
    },
}), debounced_1.default())(function (_a) {
    var styles = _a.styles, pageCount = _a.pageCount, value = _a.value, onChange = _a.onChange;
    return (react_1.default.createElement(Input_1.default, { style: styles.footerPage, value: pageCount === 0
            ? 0
            : value === ''
                ? value
                : isNaN(Number(value))
                    ? 1
                    : Number(value) >= pageCount
                        ? pageCount
                        : Number(value) <= 1
                            ? 1
                            : value, onChange: onChange, id: "page", name: "page" }));
});
var Pager = function (_a) {
    var columns = _a.columns, pageSizeItems = _a.pageSizeItems, pageSize = _a.pageSize, setPageSize = _a.setPageSize, setPage = _a.setPage, page = _a.page, count = _a.count, onPrevClick = _a.onPrevClick, numberOfEntriesLabel = _a.numberOfEntriesLabel, numberDividerLabel = _a.numberDividerLabel, onNextClick = _a.onNextClick, styles = _a.styles, emptyInput = _a.emptyInput, setEmptyInput = _a.setEmptyInput, showPagerInput = _a.showPagerInput, inputKey = _a.inputKey, refreshInput = _a.refreshInput, maxCount = _a.maxCount, onMaxCountReached = _a.onMaxCountReached;
    var start = Math.min(page * pageSize + 1, count);
    var end = Math.min((page + 1) * pageSize, count);
    var pageCount = 1;
    if (pageSize !== -1) {
        pageCount = count % pageSize === 0 ? count / pageSize : Math.ceil(count / pageSize);
    }
    var previous = start > 1;
    var next = end < count;
    return (react_1.default.createElement("tr", null,
        react_1.default.createElement("td", { style: styles.footerTd, colSpan: columns.length + 1 },
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { style: { float: 'left' } },
                    react_1.default.createElement(IconButton_1.default, { style: styles.footerPrevious, disabled: !previous || pageSize === -1, onClick: onPrevClick },
                        react_1.default.createElement(chevron_left_1.default, null)),
                    showPagerInput ? (react_1.default.createElement(DebouncedInput, { key: "" + inputKey, styles: styles, page: page, pageSize: pageSize, setPage: setPage, pageCount: pageCount, emptyInput: emptyInput, setEmptyInput: setEmptyInput, refresh: refreshInput, maxCount: maxCount, onMaxCountReached: onMaxCountReached })) : (page + 1 + " "),
                    "/ ",
                    pageCount,
                    react_1.default.createElement(IconButton_1.default, { style: styles.footerNext, disabled: !next || pageSize === -1, onClick: onNextClick },
                        react_1.default.createElement(chevron_right_1.default, null))),
                react_1.default.createElement("div", { style: { float: 'left', marginLeft: 40 } },
                    numberOfEntriesLabel,
                    react_1.default.createElement(Select_1.default, { style: styles.footerSelect, valueFunction: pageSizeValueFunc, items: pageSizeItems, value: pageSize, onChange: setPageSize, id: "pager", name: "pager" }),
                    pageSize !== -1 ? start + " - " + end + " " + numberDividerLabel + " " + count : start + " - " + count)))));
};
exports.default = recompose_1.compose(utils_1.withStyles, recompose_1.withState('emptyInput', 'setEmptyInput', false), recompose_1.withState('inputKey', 'setInputKey', false), recompose_1.withHandlers({
    refreshInput: function (_a) {
        var inputKey = _a.inputKey, setInputKey = _a.setInputKey;
        return function () { return setInputKey(!inputKey); };
    },
    onPrevClick: function (_a) {
        var page = _a.page, setPage = _a.setPage, setEmptyInput = _a.setEmptyInput;
        return function () {
            setPage(page - 1);
            setEmptyInput(false);
        };
    },
    onNextClick: function (_a) {
        var page = _a.page, pageSize = _a.pageSize, maxCount = _a.maxCount, onMaxCountReached = _a.onMaxCountReached, setPage = _a.setPage, setEmptyInput = _a.setEmptyInput;
        return function () {
            var newPage = page + 1;
            if (maxCount && (newPage + 1) * pageSize > maxCount) {
                onMaxCountReached();
            }
            else {
                setPage(newPage);
            }
            setEmptyInput(false);
        };
    },
}))(Pager);
//# sourceMappingURL=Pager.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/controls/Grid/Pager.js
// module id = 908
// module chunks = 0